import React, { useState } from "react";
import { Box, Divider, Typography } from '@mui/material';
import FormularioProgram from "../pages/Trabajos/FormularioProgram";
import FormularioInfoPrograma from "../pages/Trabajos/FormularioInfoPrograma";
import ListaImplementacion from "../pages/Trabajos/ListaImplementacion";
import ListaInfoPrograma from "../pages/Trabajos/ListaInfoPrograma";
import ProgramPages from "../pages/Trabajos/ProgramPages";

const DashboardProgramasWeb = () => {
    const [programaSeleccionado, setProgramaSeleccionado] = useState(null);
    const [infoProgramaSeleccionado, setInfoProgramaSeleccionado] = useState(null);
    
    // Función para manejar la edición de las implementaciones
    const handleEditarPrograma = (programa) => {
        setProgramaSeleccionado(programa);
        console.log('Estoy en DashboardProgramas ' + programa);
    };

    // Función para manejar la edición del infoprograma
    const handleEditarInfoPrograma = (infoprograma) => {
        setInfoProgramaSeleccionado(infoprograma);
        console.log('Estoy en DashboardProgramas ' + infoprograma);
    };

    return(
        <Box sx={{
            gap: '20px',
            margin: '10px 5px',
            textAlign: 'center',
            '@media (max-width: 600px)': {  // En móviles
                flexDirection: 'column', // Asegurarse que esté en columna
                width: '95%',
                gap: '20px',
                margin: '1% 5%',
            },
        }}>

            <Typography 
                variant='h5' 
                sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}
            >
                Sección Nuestras implementaciones
            </Typography>

            <Divider 
                sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }} 
            />
            <Box sx={{
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
            }}>
                {/*Formulario de las implementaciones */}
                <FormularioProgram programaSeleccionado={programaSeleccionado}/>

                {/*Lista de implementaciones */}
                <ListaImplementacion onEditar={handleEditarPrograma}/>

            </Box>

            <Typography 
                variant='h5' 
                sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}
            >
                Sección de la información Nuestras implementaciones
            </Typography>

            <Divider 
                sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }} 
            />
            <Box sx={{
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
            }}>

                {/*Formulario para agregar el contenido a la página web */}
                <FormularioInfoPrograma infoProgramaSeleccionado={infoProgramaSeleccionado} />

                {/*Lista de la informació que se muestra en la pagina de handleEditarInfoBlog*/}
                <ListaInfoPrograma onEditar={handleEditarInfoPrograma} />

            </Box>
            <ProgramPages/>

        </Box>
    );
};

export default DashboardProgramasWeb;